import React, { ReactNode } from 'react'
import { connect, DispatchProp } from 'react-redux'
import { Link, RouteComponentProps } from 'react-router-dom'
import { Page } from '../../../components'
import { images } from '../../../images'
import { AuthenticatedRoutable, ITown } from '../../../models'
import literalsService from '../../../services/literals-service'
import { IStoreState } from '../../../store/states'
import StyledArticle from './styles'
import { appsStyleSelected } from '../../../helpers/app'

interface IProps extends RouteComponentProps, DispatchProp<any> {
  showPaymentMethodSection: boolean
}

class ConfigurationDisplay extends AuthenticatedRoutable<IProps> {

  public get showList() {
    const { showPaymentMethodSection } = this.props
    const list = [
      {
        show: true,
        path: '/user-info',
        key: 'userInfo'
      },
      {
        show: true,
        path: '/change-password',
        key: 'changePassword'
      },
      {
        show: showPaymentMethodSection,
        path: '/payment-method',
        key: 'paymentMethod'
      },
      {
        show: true,
        path: '/change-language',
        key: 'changeLanguage'
      },
      {
        show: true,
        path: '/area-selection',
        key: 'areaSelection'
      },
      {
        show: true,
        path: '/notification-settings',
        key: 'notificationSettings'
      },
      {
        show: true,
        path: '/unsubscribe',
        key: 'unsubscribe'
      },
      {
        show: true,
        path: '/information',
        key: 'information'
      }
    ]

    return list.map((item: any)  => {
      if (item.show) {
        return (
          <section key={ item.key }>
            <Link to={ item.path } className='row'>
              <img src={ images[item.key as keyof typeof images] } alt={item.key} className='sectionIcon'/>
              <label>{ literalsService.get(item.key, true) }</label>
              <img src={ images['arrowRight'] } alt="Go" className='arrowIcon'/>
            </Link>
          </section>
        )
      }
      return null
    })
  }

  public componentDidMount(): void {
    super.componentDidMount()
  }

  public render(): ReactNode {
    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            { this.showList }
          </StyledArticle>
        </Page>
      </Page>
    )
  }
}

const mapStateToProps = ({ configuration }: IStoreState) => ({ 
  showPaymentMethodSection: configuration.showPaymentMethod
})

export default connect(mapStateToProps)(ConfigurationDisplay)
